import './polyfills';
import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Tgcc from './tgccGlobal';
import { browserHistory } from 'react-router';
import { createStore, applyMiddleware, compose } from 'redux';
import { connect } from 'react-redux';
import { Provider } from "react-redux";
import { Router, Route, hashHistory, IndexRoute } from "react-router";
import { MajorAccountsProofRevise } from './ProofRevise/MajorAccountsProofRevise';
import { MajorAccountsProofRoster } from './ProofRoster/MajorAccountsProofRoster';
import { ProductSelector } from './ProductSelector/ProductSelector';
import { DesignSelector } from './DesignSelector/DesignSelector';
import { MajorAccountsDesignListView } from './FlatPages/MajorAccountsDesignListView';
import { reducer } from './tgccReducer';
import Radium, { StyleRoot } from 'radium';
import { ChangePassword } from './Components/ChangePassword';
import { ForgotPassword } from './Components/ForgotPassword';
import { CampusForgotPassword } from './Components/CampusForgotPassword';
import { ResetPassword } from './Components/ResetPassword';
import { Message } from './Components/Message';
import { Impersonate } from './Components/Impersonate';
import { ProofPopup } from './Dashboard/ProofPopup';
import { Scroll } from './Components/Scroll';
import { TBankerForwarder } from './TBanker/TbankerForwarder';
import { MajorAccountsTVite } from './TVite/MajorAccountsTvite';
import { TViteForwarder } from './TVite/TViteForwarder';
import { CSR } from './FlatPages/CSRLinks';
import { Collection } from './Components/Collection';
import LegalPage from './Components/LegalPage';
import { FAQContent } from './Components/FAQContent';
import { MajorAccountsProductListView } from './FlatPages/MajorAccountsProductListView';
import { Campus } from './FlatPages/Campus';
import PapaJohnsLandingPage from "./PapaJohns/PapaJohnsLandingPage"
import { PapaJohnsColorSelect } from './PapaJohns/PapaJohnsColorSelect';
import { PapaJohnsSizeSelect } from './PapaJohns/PapaJohnsSizeSelect';
import {PapaJohnsRegister} from './PapaJohns/PapaJohnsRegister';
import {PapaJohnsDesignSelect} from './PapaJohns/PapaJohnsDesignSelect';
import { ViewPapaJohnsDesigns } from './PapaJohns/ViewPapaJohnsDesigns';
import {PapaJohnsConfirmDetails} from './PapaJohns/PapaJohnsConfirmDetails';
import PapaJohnsShirtOfTheMonth from './PapaJohns/PapaJohnsShirtOfTheMonth';
import CedLanding from './Ced/CedLanding';
import { CampusDashboard } from './Dashboard/CampusDashboard';
import { CampusFAQ } from './FlatPages/CampusFAQ';
import { CampusProofEdit } from './ProofEdit/CampusProofEdit';
import { CampusLogin } from './Components/CampusLogin';
import { CampusRegister } from './Components/CampusRegister';
import { CampusDesignListView } from './FlatPages/CampusDesignListView';
import { CampusProductListView } from './FlatPages/CampusProductListView';
import { CampusProofView } from './FlatPages/CampusProofView';
import { CampusProofRevise } from './ProofRevise/CampusProofRevise';
import { CampusProofRoster } from './ProofRoster/CampusProofRoster';
import { TBanker } from "./TBanker/TBanker";
import { CampusTVite } from "./TVite/CampusTVite";
import { CampusContact } from './Contact/CampusContact';
import { CampusProofPopup } from './Dashboard/CampusProofPopup';
import { Schools } from './FlatPages/Schools';
import { PaymentOptions } from './FlatPages/PaymentOptions';
import { OtherSchools } from './FlatPages/OtherSchools';
import { CampusServiceContent } from './Components/CampusServiceContent';
import { AccountSetup } from './Components/AccountSetup';
import { CampusAbout } from './FlatPages/CampusAbout';
import { CampusShipping } from './FlatPages/CampusShipping';
import { SplashPage } from './HomePage/SplashPage';
import { MajorAccounts } from './FlatPages/MajorAccounts';
import { MajorAccountsLogin } from './Components/MajorAccountsLogin';
import { MajorAccountsRegister } from "./Components/MajorAccountsRegister";
import { MajorAccountsDash } from "./Dashboard/MajorAccountsDash";
import { MajorAccountsProofView } from './FlatPages/MajorAccountsProofView';
import { MajorAccountsContact } from "./Contact/MajorContact";
import { MajorAccountsAbout } from './FlatPages/MajorAccountsAbout';
import { MajorAccountsServiceContent } from './Components/MajorAccountsServiceContent';
import { MajorAccountsPaymentOptions } from "./FlatPages/MajorAccountsPaymentOptions";
import { MajorAccountsFAQ } from "./FlatPages/MajorAccountsFAQ";
import { MajorAccountsProofEdit } from './ProofEdit/MajorAccountsProofEdit';
import {EstimateApprove} from './Components/Estimates/EstimateApprove';
import { ArtFeePay } from './Components/PaymentLinks/ArtFeePay';
import {EstimateChanges} from './Components/Estimates/EstimateChanges'
import { EnLargeUpload } from "./Components/EnLargeUpload";
import { MajorAccountShipping } from "./FlatPages/MajorAccountShipping";
import { CampusHowItWorks } from "./FlatPages/CampusHowItWorks";
import { TShirtHero } from "./Components/TShirtHero/TShirtHero";
import { TShirtHeroVideo } from "./Components/TShirtHero/TShirtHeroVideo";
import { TShirtHeroLearnMore } from "./Components/TShirtHero/TShirtHeroLearnMore";
import { TShirtHeroTerms } from "./Components/TShirtHero/TShirtHeroTerms";
import { ConfirmApproval } from "./Components/ConfirmApproval";
import { ApprovalConfirmation } from "./Components/ApprovalConfirmation";
import ConfirmEmail  from "./Components/ConfirmEmail";
import { CampusFeedback } from "./FlatPages/CampusFeedback";
import { MajorAccountsFeedback } from "./FlatPages/MajorAccountsFeedback";
import { CampusSearch } from './FlatPages/CampusSearch';
import { DesignSearchView } from './FlatPages/DesignSearchView';
import { IndigoRegister } from "./Indigo/IndigoRegistration";
import { IndigoLogin } from "./Indigo/IndigoLogin";
import { IndigoDashboard } from "./Indigo/IndigoDashboard";
import { IndigoHome } from './Indigo/IndigoHome';
import { IndigoProofEdit } from './Indigo/IndigoProofEdit';
import { IndigoDesignListView } from './Indigo/IndigoDesignListView';
import { IndigoProductListView } from "./Indigo/IndigoProductListView";
import { IndigoProofView } from './Indigo/IndigoProofView';
import { IndigoProofRevise } from './Indigo/IndigoProofRevise';
import { IndigoFAQ } from './Indigo/IndigoFAQ';
import { IndigoContact } from './Indigo/IndigoContact'
import { IndigoShipping } from './Indigo/IndigoShippingReturns';
import { IndigoAbout } from './Indigo/IndigoAbout';
import { CsrChanges } from "./FlatPages/CsrChanges";
import { MajorAccountsLanding } from "./FlatPages/MajorAccountsLanding";
import { K12Landing } from "./K12/K12Landing";
import { CampusMerch } from "./FlatPages/CampusMerch";
import { Catalog } from './Components/Catalog';
import { Webstore } from './Components/Webstore';
import { CsrDtdSamplePrint } from './FlatPages/CsrDtdSamplePrint';
import { RealCollection } from "./RealCampus/RealCollection";
import { RealCollectionListView } from "./RealCampus/RealCollectionListView";
import { RealCampusProductListView } from "./RealCampus/RealCampusProductListView";
import { RealCampus } from './RealCampus/RealCampusHome';
import { RealCampusProofEdit } from "./RealCampus/RealCampusProofEdit";
import { RealCampusDesignListView } from "./RealCampus/RealCampusDesignListView";
import { RealCampusRegister } from "./RealCampus/RealCampusRegister";
import { RealCampusLogin } from './RealCampus/RealCampusLogin';
import { RealCampusDashboard } from './RealCampus/RealCampusDashboard';
import { RealCampusProofRevise } from "./RealCampus/RealCampusProofRevise";
import { RealCampusPaymentOptions } from './RealCampus/RealCampusPaymentOptions';
import { RealCampusProofRoster } from './RealCampus/RealCampusProofRoster';
import { RealCampusProofView } from './RealCampus/RealCampusProofView';
import { RealCampusTVite } from './RealCampus/RealCampusTVite';
import { RealCampusSchoolRequest } from "./RealCampus/RealCampusSchoolRequest";
import { RealCampusServiceContent } from './RealCampus/RealCampusServiceContent';
import { RealCampusProofPopup } from './RealCampus/RealCampusProofPopup';
import { Shop } from './Components/WebShop/Shop';
import { CatalogDesignListView } from './Components/CatalogDesignListView';
import { ProductCategoryIcons } from "./FlatPages/ProductCategoryIcons";
import { setAuthToken } from './tgccRequest';

declare global {
    interface Window {
        __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
    }
}
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

class AppProps extends Tgcc.BaseProps {
    user?: any;
    children: any;
};

class _TgccApp extends React.Component<AppProps, any> {

    componentWillMount() {
        // 1) initialize Redux with an empty UserInfo
        this.props.dispatch({
          type: Tgcc.StateAction.SetUserInfo,
          payload: new Tgcc.UserInfo()
        });
    
        // 2) pull anything stashed in localStorage
        const uData = Tgcc.LoadUserData();
        if (uData && uData.userInfo && uData.loginData) {
          // 3) populate Redux
          this.props.dispatch({
            type: Tgcc.StateAction.LocalUserDataLoaded,
            payload: {
              UserInfo: uData.userInfo,
              LoginData: uData.loginData
            }
          });
    
          // 4) prime the authToken in tgccRequest so all future calls include it
          setAuthToken(uData.loginData.token);
        }
      }

    componentWillReceiveProps(props: AppProps) {
        if (props.state.ForwardLocation) {
            var newloc = props.state.ForwardLocation;
            props.dispatch({ type: Tgcc.StateAction.ForwardLocation, payload: null });
            if (window.location.href.indexOf(newloc) < 0)
                browserHistory.push(newloc);
        }
    }

    closeDialog = () => {
        this.props.dispatch({ type: Tgcc.StateAction.DialogAction, payload: null });
    }

    getDialog = () => {
        if (this.props && this.props.state && this.props.state.DialogAction) {
            var dlgAction = this.props.state.DialogAction;
            switch (dlgAction.action) {
                case Tgcc.DialogAction.ChangePassword: return <ChangePassword />
                case Tgcc.DialogAction.ProofPopup: return <ProofPopup />
                case Tgcc.DialogAction.CampusProofPopup: return <CampusProofPopup />
                case Tgcc.DialogAction.RealCampusProofPopup: return <RealCampusProofPopup />
                case Tgcc.DialogAction.Impersonate: return <Impersonate />
                case Tgcc.DialogAction.ForgotPassword: return <ForgotPassword email={dlgAction.payload.email} />
                case Tgcc.DialogAction.CampusForgotPassword: return <CampusForgotPassword email={dlgAction.payload.email} />
                case Tgcc.DialogAction.ResetPassword: return <ResetPassword token={dlgAction.payload.token} email={dlgAction.payload.email} />
                case Tgcc.DialogAction.MessagePopup: return <Message Title={dlgAction.payload.title} Message1={dlgAction.payload.message} onContinue={dlgAction.payload.onContinue || this.closeDialog} />
                case Tgcc.DialogAction.FAQ: return <FAQContent content={dlgAction.payload.content} question={dlgAction.payload.question} />
                case Tgcc.DialogAction.CampusServiceContext: return <CampusServiceContent title={dlgAction.payload.title} description={dlgAction.payload.description} proof={dlgAction.payload.proof} />
                case Tgcc.DialogAction.MajorAccountsServiceContext: return <MajorAccountsServiceContent title={dlgAction.payload.title} description={dlgAction.payload.description} proof={dlgAction.payload.proof} />
                case Tgcc.DialogAction.RealCampusServiceContext: return <RealCampusServiceContent title={dlgAction.payload.title} description={dlgAction.payload.description} proof={dlgAction.payload.proof} />
                case Tgcc.DialogAction.EnLargeUpload: return <EnLargeUpload src={dlgAction.payload.src} />
                case Tgcc.DialogAction.ConfirmApproval: return <ConfirmApproval Message1={dlgAction.payload.Message1} />
                case Tgcc.DialogAction.ApprovalConfirmation: return <ApprovalConfirmation onContinue={dlgAction.payload.onContinue} />
                case Tgcc.DialogAction.UserLogin: return <MajorAccountsLogin />
                default: return null;
            }
        }
    }
    getSelectorComponent = () => {
        if (this.props.state.EditState == Tgcc.EditStates.SelectProduct)
            return <ProductSelector />

        if (this.props.state.EditState == Tgcc.EditStates.SelectDesign)
            return <DesignSelector />
    }

    checkLogin = () => {
        if (this.props.state.LoginData) {
            if (Tgcc.LoginExpired(this.props.state.LoginData)) {
                this.props.dispatch({ type: Tgcc.StateAction.Logout, payload: null });
            }
        }
    }

    render() {
        if (!StyleRoot) return null;

        this.checkLogin()
        var dialogComponent = this.getDialog()
        var selectorComponent = this.getSelectorComponent();
        return (
            <StyleRoot>
                <Scroll>
                    {selectorComponent}
                    {dialogComponent}
                    {this.props.children}
                </Scroll>
            </StyleRoot>
        );
    }
}

const mapStateToProps = (state: Tgcc.GlobalState, ownState: any) => {
    return { state: state };
};
export var TgccApp = connect(mapStateToProps)(_TgccApp);
let reduxStore = createStore(
    reducer,
    new Tgcc.GlobalState(), // Your initial state
    composeEnhancers(
        applyMiddleware(
            // Your middleware, e.g., thunk
        )
        // Other enhancers if needed
    )
);

browserHistory.listen(location => reduxStore.dispatch({ type: Tgcc.StateAction.DialogAction, payload: null }));

ReactDOM.render((
    <Provider store={reduxStore}>
        <Router history={browserHistory}>
            <Route path={Tgcc.Routes.Root} component={TgccApp}>
                <IndexRoute component={SplashPage} />
                <Route path='papajohns' component={PapaJohnsLandingPage} />
                <Route path='papajohns/color-select' component={PapaJohnsColorSelect} />
                <Route path='papajohns/size-select' component={PapaJohnsSizeSelect} />
                <Route path='papajohns/register' component={PapaJohnsRegister} />
                <Route path='papajohns/select-design' component={PapaJohnsDesignSelect} />
                <Route path='account/setup' component={AccountSetup} />
                <Route path='papajohns/view-designs' component={ViewPapaJohnsDesigns} />
                <Route path='papajohns/confirm-details' component={PapaJohnsConfirmDetails} />
                <Route path='papajohns/shirt-of-the-month' component={PapaJohnsShirtOfTheMonth} />
                <Route path='ced' component={CedLanding} />
                <Route path='campus' component={Campus} />
                <Route path='campus/login' component={CampusLogin} />
                <Route path='campus/contact' component={CampusContact} />
                <Route path='campus/register' component={CampusRegister} />
                <Route path='campus/dashboard' component={CampusDashboard} />
                <Route path='campus/FAQ' component={CampusFAQ} />
                <Route path='campus/shipping' component={CampusShipping} />
                <Route path='campus/proofedit' component={CampusProofEdit} />
                <Route path='campus/proofedit(/:code)' component={CampusProofEdit} />
                <Route path='campus/designs' component={CampusDesignListView} />
                <Route path='campus/productCategories' component={ProductCategoryIcons} />
                <Route path='campusProducts' component={CampusProductListView} />
                <Route path='confirm-email' component={ConfirmEmail} />
                <Route path='campusProducts/category(/:category)' component={CampusProductListView} />
                <Route path='campusProducts/brand(/:brand)' component={CampusProductListView} />
                <Route path='campusProducts(/:brand)(/:style)(/:color)' component={CampusProductListView} />
                <Route path='campus/proofview' component={CampusProofView} />
                <Route path='campus/proofrevise' component={CampusProofRevise} />
                <Route path='campus/proofroster' component={CampusProofRoster} />
                <Route path='campus/tbanker(/:tbCode)' component={TBanker} />
                <Route path='campus/tbanker' component={TBanker} />
                <Route path='campus/tvite' component={CampusTVite} />
                <Route path='campus/tvite(/:tvCode)' component={CampusTVite} />
                <Route path='campus/schools' component={Schools} />
                <Route path='campus/licenses' component={OtherSchools} />
                <Route path='campus/paymentOptions' component={PaymentOptions} />
                <Route path='campus/about' component={CampusAbout} />
                <Route path='campus/howitworks' component={CampusHowItWorks} />
                <Route path='campus/TShirtHero' component={TShirtHero} />
                <Route path='campus/TShirtHero/your-mission' component={TShirtHeroLearnMore} />
                <Route path='campus/TShirtHero/learn-more' component={TShirtHeroLearnMore} />
                <Route path='campus/TShirtHero/terms' component={TShirtHeroTerms} />
                <Route path='campus/feedback' component={CampusFeedback} />
                <Route path='campus/search' component={CampusSearch} />
                <Route path='campus/search(/:keyword)' component={CampusSearch} />
                <Route path='campus/merch' component={CampusMerch} />
                <Route path='keyword' component={DesignSearchView} />
                <Route path='keyword(/:keyword)' component={DesignSearchView} />
                <Route path='home' component={MajorAccounts} />
                <Route path='login' component={MajorAccountsLogin} />
                <Route path='proofedit' component={MajorAccountsProofEdit} />
                <Route path='approve-estimate' component={EstimateApprove} />
                <Route path='pay-art-fee' component={ArtFeePay} />
                <Route path='edit-estimate' component={EstimateChanges} />
                <Route path='register' component={MajorAccountsRegister} />
                <Route path='dashboard' component={MajorAccountsDash} />
                <Route path='designs' component={MajorAccountsDesignListView} />
                <Route path='designs/designCat(/:category)' component={MajorAccountsDesignListView} />
                <Route path='designs/search(/:keyword)' component={MajorAccountsDesignListView} />
                <Route path='productCategories' component={ProductCategoryIcons} />
                <Route path='products' component={MajorAccountsProductListView} />
                <Route path='products/category(/:category)' component={MajorAccountsProductListView} />
                <Route path='proofview' component={MajorAccountsProofView} />
                <Route path='proofrevise' component={MajorAccountsProofRevise} />
                <Route path='paymentOptions' component={MajorAccountsPaymentOptions} />
                <Route path='tbanker' component={TBanker} />
                <Route path='tbanker(/:tbCode)' component={TBanker} />
                <Route path='tvite' component={MajorAccountsTVite} />
                <Route path='tvite(/:tvCode)' component={MajorAccountsTVite} />
                <Route path='proofroster' component={MajorAccountsProofRoster} />
                <Route path='contact' component={MajorAccountsContact} />
                <Route path='about' component={MajorAccountsAbout} />
                <Route path='csr' component={CSR} />
                <Route path='FAQ' component={MajorAccountsFAQ} />
                <Route path='feedback' component={MajorAccountsFeedback} />
                <Route path='shipping' component={MajorAccountShipping} />
                <Route path='helpthemhelpyou' component={MajorAccountsLanding} />
                <Route path='k12' component={K12Landing} />
                <Route path='programs/wogettstsbanker_member_mssql_post.asp' component={TBankerForwarder} />
                <Route path='programs/tvite_wogettstsbanker_member_mssql_post.asp' component={TViteForwarder} />
                <Route path='collection' component={Collection} />
                <Route path='collection(/:division)' component={Collection} />
                <Route path='collection(/:division)(/:theme)' component={Collection} />
                <Route path='realcampus/collection(/:division)(/:theme)' component={RealCollection} />
                <Route path='realcampus/schools' component={RealCollectionListView} />
                <Route path='realcampus' component={RealCampus} />
                <Route path='realcampus/products' component={RealCampusProductListView} />
                <Route path='realcampus/products/category(/:category)' component={RealCampusProductListView} />
                <Route path='realcampus/products(/:brand)(/:style)(/:color)' component={RealCampusProductListView} />
                <Route path='realcampus/designs' component={RealCampusDesignListView} />
                <Route path='realcampus/proofEdit' component={RealCampusProofEdit} />
                <Route path='realcampus/register' component={RealCampusRegister} />
                <Route path='realcampus/login' component={RealCampusLogin} />
                <Route path='realcampus/dashboard' component={RealCampusDashboard} />
                <Route path='realcampus/proofrevise' component={RealCampusProofRevise} />
                <Route path='realcampus/paymentOptions' component={RealCampusPaymentOptions} />
                <Route path='realcampus/proofroster' component={RealCampusProofRoster} />
                <Route path='realcampus/proofview' component={RealCampusProofView} />
                <Route path='realcampus/tvite(/:tbCode)' component={RealCampusTVite} />
                <Route path='realcampus/tvite' component={RealCampusTVite} />
                <Route path='realcampus/request' component={RealCampusSchoolRequest} />
                <Route path='indigo' component={IndigoHome} />
                <Route path='indigo/register' component={IndigoRegister} />
                <Route path='indigo/login' component={IndigoLogin} />
                <Route path='indigo/dashboard' component={IndigoDashboard} />
                <Route path='indigo/proofedit' component={IndigoProofEdit} />
                <Route path='indigo/designs' component={IndigoDesignListView} />
                <Route path='indigo/designs/designCat(/:category)' component={IndigoDesignListView} />
                <Route path='indigo/products' component={IndigoProductListView} />
                <Route path='indigo/products(/:brand)' component={IndigoProductListView} />
                <Route path='indigo/products(/:brand)(/:style)(/:color)' component={IndigoProductListView} />
                <Route path='indigo/proofview' component={IndigoProofView} />
                <Route path='indigo/proofrevise' component={IndigoProofRevise} />
                <Route path='indigo/faq' component={IndigoFAQ} />
                <Route path='indigo/contact' component={IndigoContact} />
                <Route path='indigo/shipping' component={IndigoShipping} />
                <Route path='indigo/about' component={IndigoAbout} />
                <Route path='catDesigns' component={CatalogDesignListView} />
                <Route path='csr/change' component={CsrChanges} />
                <Route path='catalog' component={Catalog} />
                <Route path='webstore' component={Webstore} />
                <Route path='csr/dtd-sample-print' component={CsrDtdSamplePrint} />
                <Route path='legal' component={LegalPage} />
                <Route path='shop(/:webStoreId)' component={Shop} />
                <Route path='*' component={Shop} />
            </Route>
        </Router>
    </Provider>
), document.getElementById('app'));
